import * as React from 'react';
import * as style from './ReviewLink.css';

export const ReviewLinkWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={style['container']}>{children}</div>;
};
